import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M20.6 12.117c-.5-.2-1.1.1-1.3.6-.4 1.1-1 2.2-1.9 3-1.4 1.5-3.5 2.3-5.6 2.3s-4.1-.8-5.7-2.4l-2.8-2.6h3.5c.6 0 1-.4 1-1s-.4-1-1-1h-6c-.1 0-.2 0-.2.1H.5s-.1 0-.1.1c-.1 0-.2.1-.2.2s0 .1-.1.1c0 .1-.1.1-.1.2v6.3c0 .6.4 1 1 1s1-.4 1-1v-3.7l2.9 2.8c1.7 1.9 4.2 2.9 6.9 2.9s5.2-1 7.1-2.9c1-1 1.9-2.3 2.4-3.7.1-.6-.2-1.2-.7-1.3m3.2-4v-6.1c0-.6-.4-1-1-1s-1 .4-1 1v3.7l-2.9-2.8c-1-1-2.3-1.9-3.7-2.4-2.6-.8-5.3-.7-7.7.5-2.4 1.1-4.2 3.1-5.1 5.7-.2.5.1 1.1.6 1.2.5.2 1.1-.1 1.3-.6.7-2 2.2-3.6 4.1-4.6 1.9-.9 4.1-1 6.1-.3 1.1.4 2.2 1 3 1.9l2.8 2.7h-3.5c-.6 0-1 .4-1 1s.4 1 1 1h6c.1 0 .3 0 .4-.1s.2-.1.3-.2 0-.1.1-.1c0-.1.1-.1.1-.2.1-.1.1-.2.1-.3"
    }, null, -1)
  ]))]))
}
export default { render: render }